/** @format */

import template from './gb-add-widget-panel.html';
import './gb-add-widget-panel.scss';

export const GbAddWidgetPanelComponent = {
    template,
    require: { gbEditTools: '^^', gbPresenter: '^^', gbApp: '^^' },
    controller: class GbAddWidgetPanelComponent {
        constructor($translate, $scope) {
            'ngInject';

            this.$scope = $scope;

            this.selectedItem = null;

            let _this = this;

            this.widgetTypeButton = class {
                constructor(params = {}) {
                    this.text = params.text;
                    this.widgetTypeSelected = params.widgetTypeSelected;
                    this.shouldShow = params.shouldShow;
                }

                isSelected() {
                    return _this.selectedItem === this;
                }

                toggle() {
                    if (_this.selectedItem === this) {
                        this.deselect();
                    } else {
                        this.select();
                    }

                    _this.clearSelectedItem();
                }

                select() {
                    _this.selectedItem = this;
                }

                deselect() {
                    _this.selectedItem = null;
                }
                shouldShow() {
                    this.shouldShow();
                }
            };

            this.textButton = new this.widgetTypeButton({
                text: $translate.instant('ADD_WIDGET_LIST_TEXT'),
                widgetTypeSelected: (widget) => this.gbPresenter.isTextWidget(widget),
                shouldShow: () => true,
            });

            this.imageButton = new this.widgetTypeButton({
                text: $translate.instant('ADD_WIDGET_LIST_IMAGE'),
                widgetTypeSelected: (widget) => this.gbPresenter.isImageWidget(widget),
                shouldShow: () => true,
            });

            this.itemTableButton = new this.widgetTypeButton({
                text: $translate.instant('ADD_WIDGET_LIST_ITEM_TABLE'),
                widgetTypeSelected: (widget) => this.gbPresenter.isItemTableWidget(widget),
                shouldShow: () => true,
            });

            this.totalRaisedButton = new this.widgetTypeButton({
                text: $translate.instant('ADD_WIDGET_TOTAL_RAISED'),
                widgetTypeSelected: (widget) => this.gbPresenter.isTotalRaisedWidget(widget),
                shouldShow: () => true,
            });

            this.notificationButton = new this.widgetTypeButton({
                text: $translate.instant('ADD_WIDGET_NOTIFICATION'),
                widgetTypeSelected: (widget) => this.gbPresenter.isNotificationWidget(widget),
                shouldShow: () => true,
            });

            this.raffleDrawButton = new this.widgetTypeButton({
                text: $translate.instant('ADD_WIDGET_RAFFLE_DRAW'),
                widgetTypeSelected: (widget) => this.gbPresenter.isRaffleDrawWidget(widget),
                shouldShow: () => true,
            });

            this.raffleWinnersButton = new this.widgetTypeButton({
                text: $translate.instant('ADD_WIDGET_RAFFLE_WINNERS'),
                widgetTypeSelected: (widget) => this.gbPresenter.isRaffleWinnersWidget(widget),
                shouldShow: () => true,
            });

            this.thermometerButton = new this.widgetTypeButton({
                text: $translate.instant('ADD_WIDGET_THERMOMETER'),
                widgetTypeSelected: (widget) => this.gbPresenter.isThermometerWidget(widget),
                shouldShow: () => true,
            });

            this.countdownButton = new this.widgetTypeButton({
                text: $translate.instant('ADD_WIDGET_COUNTDOWN'),
                widgetTypeSelected: (widget) => this.gbPresenter.isCountdownWidget(widget),
                shouldShow: () => true,
            });

            this.teamScoringButton = new this.widgetTypeButton({
                text: $translate.instant('ADD_WIDGET_TEAM_SCORING'),
                widgetTypeSelected: (widget) => this.gbPresenter.isTeamScoringWidget(widget),
                shouldShow: () => {
                    let auction = this.gbApp.getAuction();

                    return auction && auction.capture_teams !== 'off' && auction.teams_count > 0;
                },
            });

            this.honourRollButton = new this.widgetTypeButton({
                text: $translate.instant('ADD_HONOUR_ROLL'),
                widgetTypeSelected: (widget) => this.gbPresenter.isHonourRollWidget(widget),
                shouldShow: () => true,
            });

            this.widgetTypeButtons = [
                this.textButton,
                this.imageButton,
                this.itemTableButton,
                this.totalRaisedButton,
                this.notificationButton,
                this.raffleDrawButton,
                this.raffleWinnersButton,
                this.thermometerButton,
                this.countdownButton,
                this.teamScoringButton,
                this.honourRollButton,
            ];
        }

        somethingIsSelected() {
            return !!this.selectedItem;
        }

        clearSelectedItem() {
            this.gbPresenter.selectedWidgetId = null;
            this.gbPresenter.copiedWidget = null;
        }

        close() {
            this.selectedItem = null;
            this.gbPresenter.selectedWidgetId = null;
            this.gbPresenter.copiedWidget = null;

            this.gbEditTools.addWidgetButton.deselect();
        }

        selectButtonForSelectedWidget(selectedWidget) {
            let selectedWidgetButton = this.widgetTypeButtons.find((btn) => {
                return btn.widgetTypeSelected(selectedWidget);
            });

            selectedWidgetButton.select();
        }

        $onInit() {
            this.$scope.$watch(
                () => this.gbEditTools.addWidgetButton.isSelected(),
                (newVal, oldVal) => {
                    if (newVal === false) {
                        this.close();
                    }
                }
            );

            this.$scope.$on(this.gbPresenter.$deselectAllWidgetsEvent, () => {
                this.close();
            });

            this.$scope.$watch(
                () => this.gbPresenter.getCopiedWidget(),
                (newVal, oldVal) => {
                    if (newVal && newVal !== oldVal) {
                        this.gbEditTools.addWidgetButton.select();
                        this.selectButtonForSelectedWidget(newVal);
                    }
                }
            );
        }
    },
};
